import { c as _c } from "react/compiler-runtime";
import { IcoClock16, IcoReturn16 } from '@onefootprint/icons';
import { IconButton, Tooltip } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type PendingIndicatorsProps = {
  onReAdd: () => void;
};
const PendingIndicators = t0 => {
  const $ = _c(22);
  const {
    onReAdd
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "rulesNode.rule"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !t2;
  let t4;
  if ($[3] !== t) {
    t4 = t(_temp2);
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t(_temp3);
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IcoClock16 color="secondary" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5) {
    t7 = <button type="button" aria-label={t5} className="flex items-center">{t6}</button>;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t7) {
    t8 = <Tooltip disabled={t3} content={t4}>{t7}</Tooltip>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t) {
    t9 = t(_temp4);
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== onReAdd || $[17] !== t9) {
    t10 = <IconButton aria-label={t9} onClick={onReAdd} size="tiny" icon={IcoReturn16} color="secondary" />;
    $[16] = onReAdd;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t8) {
    t11 = <div className="flex gap-2 items-center">{t8}{t10}</div>;
    $[19] = t10;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};
export default PendingIndicators;
function _temp($) {
  return $.pendingDeletionTooltip;
}
function _temp2($_0) {
  return $_0.pendingDeletionTooltip;
}
function _temp3($_1) {
  return $_1.pendingDeletionAriaLabel;
}
function _temp4($_2) {
  return $_2.undoDeleteAriaLabel;
}